export default "__VITE_ASSET__CcsuE3YD__"